// import COMPANY_API from '@/api/masterData/company.js';
export const searchColumns = (ctx) => {
  return [
    {
      prop: 'personNames',
      name: '制单人',
      searchType: 'personnel',
      type: 'searchTableSpec',
      isMultiple: false,
      currentValue: ctx.query?.personNames ? ctx.query?.personNames : null,
      checkRowKeys: ctx.query.personIds,
      extraData: {
        personDepartmentCode: ctx.userInfo.departmentCode,
      },
      changeMethod: 'changePerson',
    },
    {
      prop: 'businessCompanyNo',
      name: '公司名称',
      type: 'select',
      options: ctx.companyList,
      value: 'personCompanyCode',
      label: 'personCompanyName',
      changeMethod: ctx.changeCompanyHandler,
      // disabled: !ctx.isCreate,
    },
    {
      prop: 'businessDepartmentCode',
      name: '部门',
      type: 'select',
      disabled: ctx.query?.businessCompanyNo == '',
      options: ctx.departmentList,
      value: 'personDepartmentCode',
      label: 'personDepartmentName',
      changeMethod: ctx.changeDepartmentHandler,
    },
    {
      prop: 'projectNameLike',
      name: '项目名称',
      searchType: 'projectList1',
      type: 'searchTableSpec',
      isMultiple: true,
      currentValue: ctx.query?.projectNameLike ? ctx.query?.projectNameLike : null,
      checkRowKeys: [ctx.query.projectInitiationNoLike ? ctx.query.projectInitiationNoLike : null],
      extraData: {
        projectInitiationStatusList: ['PIS04', 'PIS05', 'PIS07', 'PIS08'],
        // applyCompanyNo: ctx.query.businessCompanyNo,
        // applyDepartmentNo: ctx.query.businessDepartmentCode,
        // platformtCompany: ctx.query.businessCompanyNo,
        // recyclingtCompany: ctx.query.businessCompanyNo,

        // applyCompanyName: ctx.userInfo.companyName,
        // platformtCompanyName: ctx.userInfo.companyName,
        // recyclingtCompanyName: ctx.userInfo.companyName,
        applyDepartmentNoList: (ctx.userInfo.allDepartmentList || []).map(
          (v) => v.personDepartmentCode
        ),
      },
      changeMethod: 'changeProject',
    },
    {
      name: '结算批次号',
      prop: 'settleBatchNoLike',
      type: 'input',
    },
    // {
    //   prop: 'businessCompanyNo',
    //   name: '公司名称',
    //   type: 'ajaxSelect',
    //   apiUrl: COMPANY_API.GET_COMPANY_LIST_API,
    //   apiData: {
    //     adminFlag: ctx.userInfo.adminFlag,
    //     tenantCode: ctx.userInfo.tenantCode,
    //   },
    //   clearable: true,
    //   filterable: true,
    //   valueKey: 'companyCode',
    //   labelKey: 'companyName',
    //   changeMethod: 'changeCompanyHandler',
    //   method: 'post',
    // },
    // {
    //   prop: 'businessDepartmentCode',
    //   name: '部门',
    //   type: 'ajaxSelect',
    //   apiUrl: COMPANY_API.GET_DEPARTMENT_LIST_API,
    //   apiData: {
    //     belongCompanyCode: ctx.companyCode,
    //     tenantCode: ctx.userInfo.tenantCode,
    //   },
    //   clearable: true,
    //   filterable: true,
    //   disabled: !ctx.companyCode,
    //   valueKey: 'createDepartmentCode',
    //   labelKey: 'departmentName',
    //   method: 'post',
    // },
    {
      name: '状态',
      prop: 'processStatus',
      type: 'select',
      options: [
        {
          label: '未处理',
          value: '0',
        },
        {
          label: '已处理',
          value: '1',
        },
      ],
    },
    {
      prop: 'expenseType',
      name: '费用类型',
      type: 'select',
      options: ctx.expenseTypeList,
    },
    {
      name: '业务类别',
      prop: 'businessCategory',
      type: 'select',
      disabled: true,
      options: ctx.dictListMap?.businessCategoryPayable || [],
    },
    {
      name: '应付账期',
      prop: 'accountPeriod',
      type: 'date',
      format: 'yyyy-MM',
    },
    // projectInitiationNoLike
    // {
    //   name: '项目简称',
    //   prop: 'projectNameLike',
    //   type: 'input',
    // },

    {
      // 申请日期从
      name: '业务结算日期从',
      prop: 'periodDateFrom',
      type: 'startDaterangePicker',
    },
    {
      // 申请日期到
      name: '业务结算日期至',
      prop: 'periodDateUntil',
      type: 'endDaterangePicker',
    },
    {
      name: '供应商名称',
      prop: 'supplierNo',
      type: 'searchTableSpec',
      searchType: 'partner',
      extraData: {
        companyCode: ctx.query.businessCompanyNo,
        departmentCode: ctx.query.businessDepartmentCode,
        partnerTypes: 'HZHB02,HZHB03,HZHB09,HZHB11,HZHB13',
      },
      isMultiple: true,
      changeMethod: ctx.changeSupplyChainMethod,
    },
    {
      name: '车辆号',
      prop: 'vehicleNo',
      type: 'input',
    },
    // {
    //   name: '项目编码',
    //   prop: 'projectInitiationNoLike',
    //   type: 'input',
    // },

    {
      name: '基地名称',
      prop: 'baseNameLike',
      type: 'input',
    },
    {
      name: '费用编号',
      prop: 'expenseNoLike',
      type: 'input',
    },
    {
      // 申请日期从
      name: '业务日期从',
      prop: 'businessDateStart',
      type: 'startDaterangePicker',
    },
    {
      // 申请日期到
      name: '业务日期至',
      prop: 'businessDateEnd',
      type: 'endDaterangePicker',
    },
    {
      name: '原币结算金额(含税)',
      prop: ['originalTotalAmountStart', 'originalTotalAmountEnd'],
      type: 'inputRange',
      precision: 2, //精度，就是保留几位小数,默认两位
      max: 99999999999999.99,
    },
    // {
    //   name: '结算金额2',
    //   prop: 'maxMoney',
    //   type: 'inputRange',
    // },
    {
      name: '合同编号',
      prop: 'contractNo',
      type: 'searchTableSpec',
      searchType: 'contract',
      extraData: {
        contractCategory: 'purchase',
        contractBusinessCompanyNo: ctx.query.businessCompanyNo,
        contractBusinessDepartment: ctx.query.businessDepartmentCode,
        contractDetailCategory: 'CG01', //制单类型过滤协议的
      },
      currentValue: ctx.query.contractNo,
      isMultiple: true,
      changeMethod: ctx.changeContractMethod,
    },
    // {
    //   prop: 'delivererNo',
    //   name: '投送人',
    //   type: 'searchTableSpec',
    //   searchType: 'personnel',
    //   isMultiple: true,
    //   changeMethod: ctx.changeDelivererNameMethod,
    // },
    {
      name: '付款状态',
      prop: 'paymentStatus',
      type: 'select',
      options: [
        {
          label: '已付款',
          value: '01',
        },
        {
          label: '未付款',
          value: '02',
        },
        {
          label: '部分付款',
          value: '03',
        },
      ],
    },
    // {
    //   name: '锁定状态',
    //   prop: 'isLock',
    //   type: 'select',
    //   options: [
    //     {
    //       label: '未锁定',
    //       value: '0',
    //     },
    //     {
    //       label: '锁定',
    //       value: '1',
    //     },
    //   ],
    // },
    {
      prop: 'salesmanNo',
      name: '业务员',
      type: 'searchTableSpec',
      searchType: 'personnel',
      isMultiple: true,
      changeMethod: ctx.changeSalesmanNoMethod,
    },
  ];
};

// 默认表头
export const defaultTableColumn = [
  {
    type: 'checkbox',
    visible: true,
    width: '50',
    fixed: 'left',
  },
  // {
  //   type: 'seq',
  //   title: '序号',
  //   visible: true,
  //   width: '80',
  // },
  {
    field: 'businessCompanyName',
    title: '公司名称',
    visible: true,
  },
  {
    field: 'businessDepartmentName',
    title: '部门名称',
    visible: true,
  },
  {
    field: 'supplierName',
    title: '供应商名称',
    visible: true,
    width: '150',
  },
  {
    field: 'processStatus',
    title: '状态',
    visible: true,
  },
  {
    field: 'isIndividualPartner',
    title: '个人合作伙伴',
    visible: true,
  },
  {
    field: 'contractNo',
    title: '合同编号',
    visible: true,
  },
  {
    field: 'accountPeriod',
    title: '应付账期',
    visible: true,
    width: '150',
  },
  {
    field: 'projectInitiationNo',
    title: '项目编号',
    visible: true,
    width: '150',
  },
  {
    field: 'projectName',
    title: '项目名称',
    visible: true,
    width: '150',
  },
  {
    field: 'baseName',
    title: '基地名称',
    visible: true,
    width: '150',
  },
  {
    field: 'expenseType',
    title: '费用类型',
    visible: true,
  },
  {
    field: 'settleBatchNo',
    title: '结算批次号',
    visible: true,
  },
  {
    field: 'originalPrice',
    title: '结算单价(含税)',
    visible: true,
  },
  {
    field: 'statementQuantity',
    title: '结算数量',
    visible: true,
  },
  {
    field: 'unit',
    title: '计量单位',
    visible: true,
  },
  {
    field: 'originalAmount',
    title: '原币结算金额(含税)',
    visible: true,
  },
  {
    field: 'currencyName',
    title: '币种',
    visible: true,
  },
  {
    field: 'exchangeRate',
    title: '汇率',
    visible: true,
  },
  {
    field: 'domesticAmount',
    title: '本币结算金额(含税)',
    visible: true,
  },

  {
    field: 'paymentStatus',
    title: '付款状态',
    visible: true,
  },
  // {
  //   field: 'isLock',
  //   title: '锁定状态',
  //   visible: true,
  // },
  {
    field: 'paidAmount',
    title: '已付款金额',
    visible: true,
  },

  {
    field: 'unpaidAmount',
    title: '未付款金额',
    visible: true,
  },

  {
    field: 'periodDateFrom',
    title: '业务结算日期从',
    visible: true,
  },
  {
    field: 'periodDateUntil',
    title: '业务结算日期至',
    visible: true,
  },
  {
    field: 'expenseNo',
    title: '费用编号',
    visible: true,
  },
  {
    field: 'businessDate',
    title: '业务日期',
    visible: true,
  },
  {
    field: 'taxRate',
    title: '税率',
    visible: true,
  },

  {
    field: 'businessDocCode',
    title: '业务单据编码',
    visible: true,
  },
  // {
  //   field: 'inboundDate',
  //   title: '入库日期',
  //   visible: true,
  // },
  {
    field: 'productName',
    title: '商品名称',
    visible: true,
  },
  {
    field: 'goodsCategoryName',
    title: '商品类别',
    visible: true,
  },
  {
    field: 'vehicleNo',
    title: '车辆号',
    visible: true,
  },
  // {
  //   field: 'delivererName',
  //   title: '投送人',
  //   visible: true,
  // },
  {
    field: 'salesmanName',
    title: '业务员',
    visible: true,
  },
  {
    field: 'productModel',
    title: '规格',
    visible: true,
  },
  {
    field: 'settlementNo',
    title: '结算单编号',
    visible: true,
  },
  {
    field: 'createMethod',
    title: '创建方式',
    visible: true,
  },
];

// 默认显示的按钮
export const defaultMenuBtnList = [
  {
    id: 1,
    label: '导入',
    type: '0',
    attributes: {
      // buttonStyle: 'el-icon-remove-outline',
      buttonUrl: 'import',
    },
  },
  {
    id: 2,
    label: '导出',
    type: '0',
    attributes: {
      // buttonStyle: 'el-icon-remove-outline',
      buttonUrl: 'export',
    },
  },

  {
    id: 3,
    label: '创建结算单',
    type: '0',
    attributes: {
      // buttonStyle: 'el-icon-remove-outline',
      buttonUrl: 'create',
    },
  },
];

import BASE_API from '@/api/dataBase';
export default {
  data() {
    return {
      companyList: [],
      departmentList: [],
      expenseTypeList: [],
    };
  },
  methods: {
    // 获取公司
    async _getCompanyApi() {
      // console.log('开始获取公司', this.userInfo);
      const { data } = await this.$axios.post(BASE_API.GET_PERSON_API, {
        id: this.userInfo.userCode,
        userCode: this.userInfo.userCode,
        personName: this.userInfo.userName,
      });
      if (data.code == 0) {
        // console.log(data.data, '???=====》》');
        this.companyList = data.data?.personCompanyInfo;
        // console.log(this.companyList, 'companyList');
        // console.log(this.userInfo.companyCode, 'this.userInfo.companyCode');

        // if (!this.userInfo.companyCode) {
        //   // console.log('非userInfo');
        //   const companyCode = data.data.personCompanyInfo
        //     ? data.data.personCompanyInfo[0].companyCode
        //     : null;
        //   const companyName = data.data.personCompanyInfo
        //     ? data.data.personCompanyInfo[0].companyName
        //     : null;
        //   this.query = {
        //     ...this.query,
        //     businessCompanyNo: companyCode,
        //     businessCompanyName: companyName,
        //   };
        // } else {
        //   // console.log('userInfo');
        //   this.query = {
        //     ...this.query,
        //     businessCompanyNo: this.userInfo.companyCode,
        //     businessCompanyName: this.userInfo.companyName,
        //   };
        // }

        // this._getDepartmentByCompanyCodeApi(this.query.businessCompanyNo, true);
        this.getTableData();
      } else {
        console.error('获取公司失败');
      }
    },
    // 根据公司获取部门
    async _getDepartmentByCompanyCodeApi(companyCode, isFirst = false) {
      const { data } = await this.$axios.post(BASE_API.GET_PERSON_API, {
        id: this.userInfo.userCode,
        userCode: this.userInfo.userCode,
        personName: this.userInfo.userName,
        personCompanyCode: companyCode,
      });
      if (data.code == 0) {
        // console.log(data.data, '部门信息');
        this.departmentList = data.data?.personDepartmentInfo;
        if (isFirst) {
          this.query = {
            ...this.query,
            businessDepartmentCode: this.userInfo?.departmentCode,
            businessDepartmentName: this.userInfo?.departmentName,
          };
          setTimeout(() => {
            this.getTableData();
          }, 10);
        }
      } else {
        console.error('获取部门失败');
      }
    },
    // 切换公司
    changeCompanyHandler(val) {
      // console.log(val, '切换公司');
      const item = this.companyList.find((item) => item.personCompanyCode == val);
      // console.log(item, '切换公司item');
      this.query = {
        ...this.query,
        businessDepartmentCode: '',
        businessDepartmentName: '',
        businessCompanyNo: val,
        businessCompanyName: item.personCompanyName,
      };
      // 获取部门数据
      this._getDepartmentByCompanyCodeApi(val);
    },
    // 切换部门
    changeDepartmentHandler(val) {
      // console.log(val, '切换部门');
      // console.log(this.departmentList, 'this.departmentList');

      const item = this.departmentList.find((item) => item.personDepartmentCode == val);
      this.query = {
        ...this.query,
        businessDepartmentCode: val,
        businessDepartmentName: item.personDepartmentName,
      };
    },
  },

  mounted() {
    // this.getCompanyApi();
    this.$nextTick(() => {
      this._getCompanyApi();
    });
    // console.log(this.dictListMap?.expenseType, '费用类型-------------------------');
    this.expenseTypeList = this.dictListMap?.expenseType;
    // console.log(this.expenseTypeList, 'this.expenseTypeList');
  },
};
